/** Pagination options — aligned with Invitee list. */
export const EMAIL_TEMPLATE_PER_PAGE_OPTIONS = [15, 30, 50, 100] as const

/** Workflows that require `template_metadata` (hours), matching Angular `metaDataTypes`. */
export const META_DATA_WORKFLOW_TYPES = [
  'SYSTEM_EMAIL_APPLICATION_APPROVED',
  'INCOMPLETE_APPLICATION',
  'RESIDENT_NOT_PAID',
] as const

export const PRIMARY_BRAND = 'rgb(21 151 255)'
